import React from 'react';
import { ScrollView, View } from 'react-native'

import tw from '../../../../styles/tailwind';
import Text from '../../../../components/Text';
import Toggle from '../../../../components/Toggle';
import Header from '../../../../navigation/Header';
import useCommunitySettings from '../../../../hooks/useCommunitySettings';


type NotificationItem = {
  key: string;
  title: string;
  description: string;
  defaultValue: boolean;
};

type NotificationGroup = {
  title?: string;
  items: NotificationItem[];
};


const GROUPS: NotificationGroup[] = [
  {
    title: 'Cuotas',
    items: [
      {
        key: 'notifications.fee_created',
        title: 'Creación de cuota',
        description: 'Los residentes son notificados que una cuota extraordinaria se les ha asignado.',
        defaultValue: true,
      },
      {
        key: 'notifications.payment_confirmed',
        title: 'Pago de cuota',
        description: 'El residente recibe la confirmación de pago cuando su cuota cambie de estatus a: Pagado.',
        defaultValue: true,
      },
      {
        key: 'notifications.payment_due',
        title: 'Fecha límite de pago',
        description: 'Recordatorio del último día que tienen para pagar el mantenimiento.',
        defaultValue: true,
      },
      {
        key: 'notifications.overdue_notice',
        title: 'Aviso de morosidad',
        description: 'Envía un recordatorio automático al residente cuando su cuota de mantenimiento haya vencido.',
        defaultValue: true,
      },
    ],
  },
  {
    title: 'Comunicados',
    items: [
      {
        key: 'notifications.new_announcement',
        title: 'Nuevo Comunicado',
        description: 'Todos reciben una notificación del comunicado recién creado.',
        defaultValue: true,
      },
    ],
  },
  {
    title: 'Documentos',
    items: [
      {
        key: 'notifications.new_document',
        title: 'Nuevo Documento',
        description: 'Al subir un documento se notifica a todos los residentes.',
        defaultValue: false,
      },
    ],
  },
  {
    title: 'Invitados QR',
    items: [
      {
        key: 'notifications.qr_used',
        title: 'Entradas y salidas',
        description: 'Notificar al residente cuando su QR haya sido utilizado para acceso y salida.',
        defaultValue: false,
      },
      {
        key: 'notifications.qr_invalid',
        title: 'Código inválido',
        description: 'Notificar al residente cuando su QR caducado sea usado o se registre alguna anomalía por parte de la seguridad.',
        defaultValue: false,
      },
    ],
  },
  {
    title: 'Tags de Acceso',
    items: [
      {
        key: 'notifications.tag_created',
        title: 'Alta de Tags',
        description: 'Notificar al residente cuando se asigne un nuevo tag a su domicilio.',
        defaultValue: false,
      },
      {
        key: 'notifications.tag_deactivated',
        title: 'Desactivación de tag',
        description: 'Informa al residente sobre la suspensión de sus tags según reglamento de uso.',
        defaultValue: false,
      },
    ],
  },
];


export default function NotificationsSettingsScreen() {
  const { updateSettings, getSettingValue, isUpdating } = useCommunitySettings()

  return (
    <View style={tw`flex-1 bg-background`}>
      <Header showBackButton title="Notificaciones" style="bg-transparent" />

      <ScrollView style={tw`flex-1`} contentContainerStyle={tw`px-4 pb-10`}>
        <Text style={tw`text-gray-500 text-sm mb-4`}>
          Elige las notificaciones que llegarán a los residentes:
        </Text>

        {GROUPS.map((group, gi) => (
          <View key={gi} style={tw`bg-white rounded-2xl border border-gray-200 px-4 py-4 mb-4`}>
            {!!group.title && (
              <>
                <Text style={tw`text-secondary font-600 text-base`}>{group.title}</Text>
                <View style={tw`border-b border-gray-200 -mx-4 mt-3 mb-4`} />
              </>
            )}

            {group.items.map((item, i) => (
              <View key={item.key} style={tw.style(i > 0 && `mt-4`)}>
                <View style={tw`row items-center justify-between`}>
                  <Text style={tw`text-secondary font-600 text-base flex-1 mr-3`}>{item.title}</Text>
                  <Toggle
                    value={getSettingValue(item.key, item.defaultValue)}
                    onValueChange={(value) => updateSettings(item.key, value)}
                    disabled={isUpdating}
                  />
                </View>
                <Text style={tw`text-gray-500 text-sm mt-1`}>{item.description}</Text>
              </View>
            ))}
          </View>
        ))}
      </ScrollView>
    </View>
  );
}
